import Insights from '../views/insights/Index.vue';
import Simulator from '../views/insights/Simulator.vue';
import { checkauth } from '../Helper';

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/insights', name: 'insights', component: Insights, beforeEnter: guard },
	{ path: '/insights/simulator', name: 'insightsSimulator', component: Simulator, beforeEnter: guard },
];
